import React, { useEffect } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { useTranslation, Trans } from 'react-i18next'
// import Loading from '../components/Loading'
import { useImageTranslation } from 'src/hooks'
import { Box, Button, useMediaQuery, useTheme, CardHeader, Tab } from '@material-ui/core'
import TabContext from '@material-ui/lab/TabContext'
import TabList from '@material-ui/lab/TabList'
import TabPanel from '@material-ui/lab/TabPanel'
import { ReactComponent as Checked } from '../assets/icons/checked.svg'
import { ReactComponent as Copy } from '../mobile/assets/icons/copy.svg'
import ProductSwiperMobile from 'src/mobile/components/Homepage/ProductSroll'
import ProductSwiperPC from 'src/mobile/components/Homepage/ProductSrollDetails'
import { ReactComponent as Return } from '../assets/icons/Return.svg'
import { ReactComponent as ToOrder } from 'src/mobile/assets/icons/Home_all.svg'
import { setSelectedDoctor } from 'src/store/slices/testCenterSlice'
import TopStickyBar from 'src/mobile/layout/TopStickyBar'
import SnackbarHelperText from 'src/mobile/components/SnackbarHelperText'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { PROMOTION_CODE, productCardData } from 'src/utils/constant'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { getFaqList } from 'src/store/slices/docSlice'
import { useHistory, Link } from 'react-router-dom'
import BookingInfo from 'src/components/BookingInfo'
import ZoomImage from 'src/components/ZoomImage'
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined'
import { Helmet  } from 'react-helmet'
import { viewItem, buttonClick, addToCart  } from 'src/utils/trackingCode'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      textAlign: 'justify',
      '& sup': {
        fontSize: '10px',
      },
      marginTop: -8,
      backgroundColor: '#fff',
    },
    back: {
      margin: '24px',
      borderRadius: '100px',
      // width: '105px',
      height: '56px',
      fontSize: 16,
      [theme.breakpoints.down('xs')]: {
        // width: '81px',
        height: '40px',
        fontSize: 14,
      },
    },
    tab: {
      marginTop: '64px',
      backgroundColor: theme.palette.background.paper,
      [theme.breakpoints.down('xs')]: {
        marginTop: 0,
      },
      '& .MuiTab-wrapper': {
        fontSize: 16,
      },
    },
    tabList: {
      '& .MuiTabs-indicator': {
        backgroundColor: '#F2512D',
      },
      '& .MuiTab-wrapper': {
        fontWeight: 600,
      },
      borderBottom: '1px solid #E5E7EB',
    },
    flexContainer: {
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'space-around',
      },
    },
    viewAllbtnIcon: {
      marginLeft: theme.spacing(1),
    },
    bannerWrapper: {
      marginTop: -100,
      [theme.breakpoints.down('xs')]: {
        height: theme.spacing(33.125),
      },
      display: 'grid',
      position: 'relative',
    },
    titleWrapper: {
      gridArea: '1/1',
      display: 'grid',
      height: '100%',
      position: 'relative',
      flexDirection: 'column',
    },
    breakTitle: {
      wordBreak: 'keep-all',
      whiteSpace: 'break-spaces',
    },
    banner: {
      display: 'block',
      position: 'relative',
      width: '100%',
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    cardHeader: {
      paddingTop: 16,
      paddingBottom: 8,
    },
    productAvtar: {
      borderRadius: 8,
      display: 'block',
      height: '420px',
      width: 630,
      marginLeft: '20px',
      [theme.breakpoints.down('xs')]: {
        width: '90%',
        margin: '8px auto',
        background: '#Fff',
        height: 'auto',
      },
    },
    tableImg: {
      width: '100%',
    },
    checkIcon: {
      width: theme.spacing(5),
      height: theme.spacing(5),
      [theme.breakpoints.down('xs')]: {
        minWidth: theme.spacing(3),
        height: theme.spacing(3),
      },
    },
    button: {
      height: '56px',
      fontSize: '18px',
      maxWidth: '294px',
      fontWeight: 700,
      marginLeft: 20,
      [theme.breakpoints.down('xs')]: {
        width: '300px',
        marginLeft: 0,
        marginTop: '20px',
        fontSize: '18px',
        height: '56px',
      },
    },
    hoverstyle: {
      cursor: 'pointer',
    },
  }),
)

const ProductInfoNPC = () => {
  const { t, i18n } = useTranslation()
  const classes = useStyles({ language: i18n.language })
  const dispatch = useDispatch()
  const [tImage] = useImageTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const history = useHistory()
  
  useEffect(() => {
    const ecommerce = {
      currency: 'HKD',
      value: 2200,
      items: getItems(),
    }
    viewItem(ecommerce)
  }, [])

  useEffect(async () => {
    // window.scrollTo({ top: 0, behavior: 'smooth' })
    // document.querySelector('return').scrollIntoView()
    document.getElementById('return').scrollIntoView()
    dispatch(getFaqList({ faqIds: [14, 17, 34, 33, 27, 26] }))
  }, [])

  const getItems = () => {
    const data = productCardData.filter((ele) => ele.package === '1')
    const items =
      data.length > 0 &&
      data.map((ele) => ({
        item_id: ele.id,
        item_name: ele.nameHK,
        index: ele.index,
        price: ele.price,
      }))
    return items.length > 0 ? items : []
  }


  const addTrackingCode = (item) => {
    const ecommerce = {
      currency: 'HKD',
      value: '2200',
      items: [item]
    }
    addToCart(ecommerce)
  }
  const [value, setValue] = React.useState('1')

  const handleChangeTab = (event, newValue) => {
    const buttonName = newValue === '1' ? 'EH_ProphecyPage_Details_Tab' : 'EH_ProphecyPage_Reminders_Tab'
    buttonClick(buttonName, buttonName)
    setValue(newValue)
  }

  const conference = [
    {
      item: 'Chan, K. C. Allen, et al. “Analysis of Plasma Epstein–Barr Virus DNA to Screen for Nasopharyngeal Cancer.” New England Journal of Medicine, vol. 377, no. 6, 2017, pp. 513–22.',
    },
    {
      item: ' Lam, W. K. Jacky, et al. “Sequencing-Based Counting and Size Profiling of Plasma Epstein–Barr Virus DNA Enhance Population Screening of Nasopharyngeal Carcinoma.” Proceedings of the National Academy of Sciences, vol. 115, no. 22, 2018, pp. E5115–24.',
    },
    {
      item: 'Chang, Kai-Ping, et al. “Complementary Serum Test of Antibodies to Epstein-Barr Virus Nuclear Antigen-1 and Early Antigen: A Possible Alternative for Primary Screening of Nasopharyngeal Carcinoma.” Oral Oncology, vol. 44, no. 8, 2008, pp. 784–92.',
    },
    {
      item: 'Tay, Joshua K., et al. “Screening in Nasopharyngeal Carcinoma: Current Strategies and Future Directions.” Current Otorhinolaryngology Reports, vol. 2, no. 1, 2013, pp. 1–7.',
    },
  ]
  const greenCheck = [
    {
      intro: t('productPage.NPC.special.1'),
    },
    {
      intro: (
        <Trans i18nKey="productPage.NPC.special.2">
          .<sup>4,5</sup>.<sup>5</sup>
        </Trans>
      ),
    },
    {
      intro: t('productPage.NPC.special.3'),
    },
    {
      intro: (
        <Trans i18nKey="productPage.NPC.special.4">
          .<sup>4,5</sup>.<sup>5</sup>
        </Trans>
      ),
    },
    {
      intro: t('productPage.NPC.special.5'),
    },
    {
      intro: t('productPage.NPC.special.6'),
    },
  ]

  return (
    <Box className={classes.root}>
      <Helmet>
        <meta name="description" content={t('seoDescription.take2prophecy')} />
        <title>{t('seoTitle.take2prophecy')}</title>
      </Helmet>
      <TopStickyBar>
        <SnackbarHelperText>
          <CardHeader
            classes={{
              root: classes.cardHeader,
              avatar: classes.cardHeaderAvatar,
            }}
            title={
              <Box alignItems="center" display="flex" fontWeight="400">
                <Box fontSize="h5.fontSize" component="span" mr={3} flexShrink="0" width="90%">
                  <Box fontSize="body1.fontSize">
                    {t('glossary.promotion.first_time_sign_up_get_discount', { field: PROMOTION_CODE })}
                  </Box>
                </Box>
                <CopyToClipboard
                  text={PROMOTION_CODE}
                  onCopy={() => {
                    toast.success(t('toast.promo_code_copy_success'))
                    buttonClick('EH_PromoCode_Copy', 'EH_PromoCode_Copy')
                  }}
                  className={classes.hoverstyle}
                >
                  <Box borderRadius={20} height={20} alignItems="center" justifyContent="center">
                    <Copy />
                  </Box>
                </CopyToClipboard>
              </Box>
            }
            disableTypography
          />
        </SnackbarHelperText>
      </TopStickyBar>
      <Box>
        <Box>
          <Button
            variant="outlined"
            className={classes.back}
            component={Link}
            onClick={() => history.push('/ProductList')}
            id="return"
          >
            <Return />
            <Box mr={0.5}>
              {t('glossary.product_list')}
              {/* {t('common.product_list')} */}
            </Box>
          </Button>
          {/* <img
            className={classes.productAvtar}
            src={tImage('Prophecy_3x2', 'webp')}
            alt="product info banner"
          /> */}
        </Box>
        <Box
          bgcolor="#fff"
          display="flex"
          flexDirection={isMobile ? 'column' : 'row'}
          justifyContent="space-evenly"
        >
          <ZoomImage
            imageStyle={classes.productAvtar}
            srcThumbnail={tImage('Prophecy_3x2', 'webp')}
            src={tImage('Prophecy_3x2', 'webp')}
            alt="product info banner"
          />{' '}
          <Box>
            <Box className={classes.title}>
              <Box
                fontSize={isMobile ? 20 : 32}
                color="primary.main"
                fontWeight={700}
                className={classes.breakTitle}
                ml={2.5}
              >
                {t('glossary.prophecy')}
              </Box>
            </Box>
            <Box
              fontSize={isMobile ? 18 : 26}
              fontWeight={700}
              my={isMobile ? 1 : 3}
              color="secondary.main"
              ml={2.5}
            >
              HKD2,200
              {/* HKD$2,200 */}
            </Box>

            <Box
              fontSize={isMobile ? 16 : 16}
              fontWeight={400}
              maxWidth="600px"
              lineHeight={1.5}
              wordBreak="break-word"
              color="grey.700"
              mx={2.5}
            >
              {t('productPage.NPC_intro')}
            </Box>
            {!isMobile && (
              <Box mt={3} display="flex" justifyContent={isMobile ? 'center' : ''} mb={3}>
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  color="secondary"
                  className={classes.button}
                  id="EH_ProductPage_Prophecy_Book_Button1"
                  onClick={() => {
                    dispatch(
                      setSelectedDoctor({
                        package: '1',
                        price: '2200',
                        currency: 'HKD',
                      }),
                    )
                    const items = getItems()
                    if (items.length > 0) {
                      addTrackingCode(items[0])
                      // selectItem('product_list', 'Product List', items[0], items[0]?.index)
                    }
                    if (isMobile) {
                      history.push(`/${i18n.language}/clinic/`, { tab: '1', price: '2200', currency: 'HKD' })
                    } else {
                      history.push(`/${i18n.language}/clinic/`, { tab: '1', price: '2200', currency: 'HKD' })
                    }
                  }}
                >
                  <Box>{t('glossary.book_now')}</Box>
                  {isMobile ? '' : <ToOrder className={classes.viewAllbtnIcon} />}
                </Button>
              </Box>
            )}
            {isMobile && (
              <Box
                p={1}
                bgcolor="#ffff"
                display="flex"
                justifyContent={isMobile ? 'center' : ''}
                position="fixed"
                bottom={0}
                zIndex="1209"
                width="100%"
              >
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  color="secondary"
                  // className={classes.button}
                  style={{ height: 56, width: '100%' }}
                  id="EH_ProductPage_Prophecy_Book_Button1"
                  onClick={() => {
                    dispatch(
                      setSelectedDoctor({
                        package: '1',
                        price: '2200',
                        currency: 'HKD',
                      }),
                    )
                    const items = getItems()
                    if (items.length > 0) {
                      addTrackingCode(items[0])
                      // selectItem('product_list', 'Product List', items[0], items[0]?.index)
                    }
                    if (isMobile) {
                      history.push(`/${i18n.language}/clinic/`, { tab: '1', price: '2200', currency: 'HKD' })
                    } else {
                      history.push(`/${i18n.language}/clinic/`, { tab: '1', price: '2200', currency: 'HKD' })
                    }
                  }}
                >
                  <Box>{t('glossary.book_now')}</Box>
                  {isMobile ? '' : <ToOrder className={classes.viewAllbtnIcon} />}
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </Box>{' '}
      <Box className={classes.tab}>
        <TabContext value={value}>
          <TabList
            onChange={handleChangeTab}
            aria-label="lab API tabs example"
            classes={{ flexContainer: classes.flexContainer }}
            centered
            className={classes.tabList}
          >
            <Tab label={t('productPage.NPC.detail')} value="1" />
            <Tab label={t('productPage.NPC.booking_info')} value="2" />
          </TabList>

          <TabPanel value="1">
            {isMobile ? (
              <Box fontWeight={900} fontSize={20} mt={4} mx={1}>
                {t('productPage.NPC.table_intro')}
              </Box>
            ) : (
              ''
            )}

            <Box maxWidth={855} margin="0 auto">
              <Box
                textAlign="center"
                mt={2}
                width="100%"
                id={isMobile ? 'EH_ProductPage_Prophecy_USP_Table_Swipe' : ''}
              >
                {/* <img
                  className={classes.tableImg}
                  src={tImage('table_NPC', 'webp')}
                  alt="product info banner"
                /> */}
                <ZoomImage
                  imageStyle={classes.tableImg}
                  srcThumbnail={tImage('table_NPC', 'webp')}
                  src={tImage('table_NPC', 'webp')}
                  alt="product info banner"
                />
              </Box>
              {!isMobile ? (
                <Box fontWeight={600} fontSize={23} mt={4.5} ml={4} textAlign="left">
                  {t('productPage.NPC.table_intro')}
                </Box>
              ) : (
                ''
              )}
              <Box mt={isMobile ? 1 : 3} ml={isMobile ? 0 : 4}>
                {greenCheck.map((item, index) => (
                  <Box display="flex" key={index} alignItems="center" my={1.5}>
                    <Box>
                      <Checked className={classes.checkIcon} />
                    </Box>
                    <Box fontSize={16} fontWeight={400} mx={isMobile ? 1 : 1.5} textAlign="left">
                      {item.intro}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </TabPanel>
          <TabPanel value="2">
            <BookingInfo />
          </TabPanel>
        </TabContext>
      </Box>
      <Box bgcolor="#fff">
        <Box
          bgcolor="#F9FAFB"
          pt={isMobile ? 2 : 8}
          pl={isMobile ? 0 : 13}
          pr={isMobile ? 0 : 13}
          pb={isMobile ? 2 : 8}
        >
          <Box fontSize="20px" color="#111827" lineHeight="150%" mt={2}>
            <Box fontWeight="fontWeightBold" component="span" ml={isMobile ? 3 : 0}>
              {t('productPage.NPC.related_pro')}
            </Box>
          </Box>
          <Box ml={isMobile ? 2 : 0} pb={isMobile ? 2 : 0}>
            {isMobile ? <ProductSwiperMobile data="1" /> : <ProductSwiperPC data="2" />}
          </Box>
        </Box>
        <Box textAlign="center" mb={5} mt={2}>
          <Button
            variant="outlined"
            fullWidth
            size="large"
            className={classes.button}
            component={Link}
            to="/faq"
            onClick={() => buttonClick('EH_ProphecyPage_FAQ', 'EH_ProphecyPage_FAQ')}
          >
            <HelpOutlineOutlinedIcon /> {t('productPage.anchor.4')}
          </Button>
        </Box>
        <Box py={2} ml={isMobile ? 0 : 13.25} mr={isMobile ? 0 : 13.25}>
          <Box color="#979797" px={isMobile ? 3 : 1}>
            {t('productPage.renfrence')}
          </Box>
          {conference.map((x, index) => (
            <Box
              key={index}
              fontSize="12px"
              lineHeight={1.5}
              color="#979797"
              px={isMobile ? 3 : 1}
              textAlign="left"
              display="flex"
            >
              <Box pr={1}>{index + 1}.</Box>
              <Box dangerouslySetInnerHTML={{ __html: x.item }} textAlign="left" />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default ProductInfoNPC
